<template>
  <div class="avatar-upload text-center">
    <input ref="fileInput" type="file" :accept="accept" :disabled="disabled" :multiple="multiple"
      @change="selectPictureFromInput($event)" style="display: none" />

    <v-avatar size="88" class="pos-relative grayLight cursor-pointer" @click="handleClick">
      <template v-if="imageUrl">
        <img :src="imageUrl" alt="avatar" />
      </template>

      <v-icon class="pos-absolute icon-tam-32" color="white">
        $cameraIcon
      </v-icon>
    </v-avatar>

    <v-messages v-if="errorMessages && errorMessages.length" :value="errorMessages" />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "UploadProfile",
  components: { ValidationProvider, ValidationObserver },

  props: {
    disabled: { type: Boolean, default: false },
    transparent: { type: Boolean, default: false },
    onSelectedPicture: { type: Function },
    errorMessages: { type: Array, default: () => [] },
    accept: {
      type: String,
      default: "image/png, image/jpeg, image/jpg",
    },
    placeholder: { type: String, default: "Image" },
    prependIcon: { type: String, default: "fas fa-camera" },
    label: { type: String, default: "" },
    multiple: { type: Boolean, default: false },
    validate: { type: Function },
    // 🟢 Nueva prop para imagen del backend
    defaultImage: { type: String, default: null },
  },

  data() {
    return {
      imageUrl: null,
    };
  },

  mounted() {
    // 🟢 Si hay imagen del backend, se muestra al montar
    if (this.defaultImage) {
      this.imageUrl = this.defaultImage;
    }
  },

  watch: {
    // 🟢 Si cambia la imagen desde el backend, también se actualiza
    defaultImage(newVal) {
      this.imageUrl = newVal;
    },
  },

  methods: {
    handleClick() {
      if (this.disabled) return;
      this.$refs.fileInput?.click();
    },

    selectPictureFromInput(event) {
      const files = event.target.files;
      if (!files || !files.length) return;

      if (!this.multiple) {
        this.onSelectedPicture?.(files[0]);
      } else {
        this.onSelectedPicture?.(files);
      }

      const file = files[0];
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    selectPicture(files) {
      if (!this.multiple) {
        if (files.length) {
          this.onSelectedPicture?.(files[0]);
        } else {
          this.onSelectedPicture?.(files);
        }
      } else {
        this.onSelectedPicture?.(files);
      }
    },
  },
};
</script>
